// 协议管理
export default [
  {
    path: "/agreement",
    meta: { title: "协议管理" },
    component: () => import("../views/agreement/index.vue"),
    children: [
      {
        path: "/agreement/list",
        name: "agreementLlist",
        meta: { title: "协议列表", isMenu: true },
        component: () => import("../views/agreement/list.vue"),
      },
      {
        path: "/agreement/list/detail/item",
        name: "agreementitem",
        meta: { title: "详情" },
        component: () => import("../views/agreement/detail/item"),
      },
    ],
  },
]
